import { lazyLoad } from 'utils/loadable';

export const Feedback = lazyLoad(
  () => import('./index'),
  (module) => module.FeedbackList
);
